import React from 'react';
import DefaultAutoComplete from 'components/Utils/DefaultAutoComplete';
import DefaultTextField from 'components/Utils/DefaultTextField';
import DefaultSelectField from 'components/Utils/DefaultSelectField';
import Icon from 'components/Utils/NewIcon';
import './DosingInstructionsInput.scss';
import { IconButton } from '@material-ui/core';
import { v4 as uuidV4 } from 'uuid';
import { DRUG_AUTOCOMPLETE_SOURCE } from 'components/HealthRecords/Prescriptions/NewPrescription/view';

const CONNECTOR_OPTIONS = ['AND', 'THEN'];

const DosingInstructionsInput = ({ dosingInstructions = [], change, allowAdd, routeField }) => {
  const updateDosingInstructions = (newInstructions) => {
    change('dosing_instructions', newInstructions);
  };

  // Ensure we always have at least one row
  const instructions =
    dosingInstructions.length === 0
      ? [
          {
            id: 1,
            dosage: '',
            dosage_unit: '',
            frequency: '',
            time: '',
            time_unit: '',
            connector: 'THEN',
          },
        ]
      : dosingInstructions;

  const addDosingRow = () => {
    const lastRow = instructions[instructions.length - 1];
    const newRow = {
      id: uuidV4(),
      dosage: lastRow?.dosage || '',
      dosage_unit: lastRow?.dosage_unit || '',
      frequency: lastRow?.frequency || '',
      time: lastRow?.time || '',
      time_unit: lastRow?.time_unit || '',
      connector: 'THEN',
    };
    updateDosingInstructions([...instructions, newRow]);
  };

  const removeDosingRow = (id) => {
    if (instructions.length > 1) {
      updateDosingInstructions(instructions.filter((row) => row.id !== id));
    }
  };

  const updateDosingRow = (id, field, value) => {
    const updated = instructions.map((row) => (row.id === id ? { ...row, [field]: value } : row));
    updateDosingInstructions(updated);
  };

  return (
    <div className="dosing-instructions-input">
      {instructions.map((row, index) => (
        <div key={row.id} className="dosing-row">
          <DefaultTextField
            id={`dosage-field-${index}`}
            label=""
            style={{ width: '60px' }}
            placeholder="Dosage"
            value={row.dosage}
            onChange={(event) => updateDosingRow(row.id, 'dosage', event.target.value)}
          />

          <DefaultAutoComplete
            id={`dosage_unit-field-${index}`}
            style={{ width: '110px' }}
            placeholder="Unit"
            input={{
              value: row.dosage_unit || '',
              onChange: (value) => updateDosingRow(row.id, 'dosage_unit', value),
            }}
            onUpdateInput={(value) => updateDosingRow(row.id, 'dosage_unit', value)}
            dataSource={DRUG_AUTOCOMPLETE_SOURCE.dosage_unit}
          />

          {routeField}

          <DefaultAutoComplete
            id={`frequency-field-${index}`}
            style={{ width: '150px' }}
            placeholder="Frequency"
            input={{
              value: row.frequency || '',
              onChange: (value) => updateDosingRow(row.id, 'frequency', value),
            }}
            onUpdateInput={(value) => updateDosingRow(row.id, 'frequency', value)}
            dataSource={DRUG_AUTOCOMPLETE_SOURCE.frequency}
          />

          <DefaultTextField
            id={`time-field-${index}`}
            label=""
            style={{ width: '50px' }}
            placeholder="Time"
            value={row.time}
            onChange={(event) => updateDosingRow(row.id, 'time', event.target.value)}
          />

          <DefaultAutoComplete
            id={`time_unit-field-${index}`}
            style={{ width: '100px' }}
            placeholder="Unit"
            input={{
              value: row.time_unit || '',
              onChange: (value) => updateDosingRow(row.id, 'time_unit', value),
            }}
            onUpdateInput={(value) => updateDosingRow(row.id, 'time_unit', value)}
            dataSource={DRUG_AUTOCOMPLETE_SOURCE.time_unit}
          />

          {instructions.length > 1 && (
            <>
              <DefaultSelectField
                id={`connector-${index}`}
                label=""
                value={row.connector}
                onChange={(event) => updateDosingRow(row.id, 'connector', event.target.value)}
                inputs={CONNECTOR_OPTIONS}
                style={{ width: '70px' }}
              />

              <Icon
                src="trash"
                alt="Remove"
                className="remove-row"
                onClick={() => removeDosingRow(row.id)}
                showTooltip={true}
                height="16px"
                style={{ cursor: 'pointer' }}
              />
            </>
          )}
          {allowAdd && index === dosingInstructions.length - 1 && (
            <IconButton onClick={addDosingRow} style={{ padding: '8px' }}>
              <Icon
                src="plus"
                alt="Add Phase"
                className="add-row-button"
                showTooltip={true}
                height="16px"
                style={{ cursor: 'pointer' }}
              />
            </IconButton>
          )}
        </div>
      ))}
    </div>
  );
};

export default DosingInstructionsInput;
